import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Solutions from "@/pages/Solutions";
import OurWork from "@/pages/OurWork";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import MetisPage from "@/pages/metis/MetisPage";
import CreativeLayout from "@/pages/creative/CreativeLayout";
import CreativePortfolio from "@/pages/creative/CreativePortfolio";
import CreativeCaseStudy from "@/pages/creative/CreativeCaseStudy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/our-work" element={<OurWork />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route element={<CreativeLayout />}>
            <Route path="/mycreative" element={<CreativePortfolio />} />
            <Route path="/mycreative/:slug" element={<CreativeCaseStudy />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/metis" element={<MetisPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(18,18,18,0.9)",
            border: "1px solid rgba(57,255,20,0.22)",
            color: "#fff",
            backdropFilter: "blur(12px)",
          },
        }}
      />
    </div>
  );
}

export default App;
